import { gql } from "@apollo/client"

const GET_LOCATIONS = gql`
  query($input: LocationsInput!) { 
    locations(input: $input) {
      id
      name
    }
  }
`

export { GET_LOCATIONS }